"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadForm = void 0;
const upload_form_component_1 = __importDefault(require("./upload-form.component"));
exports.UploadForm = upload_form_component_1.default;
